import { createSlice } from '@reduxjs/toolkit'

export interface VerticallySplitLayoutState {
  contentFocus: {
    isBottomDisplayed: boolean
    isBottomExpanded: boolean
    isTopDisplayed: boolean
    isTopExpanded: boolean
  }
}

const initialState: VerticallySplitLayoutState = {
  contentFocus: {
    isBottomDisplayed: true,
    isBottomExpanded: false,
    isTopDisplayed: true,
    isTopExpanded: false,
  },
}

export const verticallySplitLayoutSlice = createSlice({
  name: 'verticallySplitLayout',
  initialState,
  reducers: {
    updateLayout: (state, action) => {
      state.contentFocus = { ...action.payload }
    },
  },
})

export const { updateLayout } = verticallySplitLayoutSlice.actions

export default verticallySplitLayoutSlice.reducer
